export default {
  Title: 'Services Offered',
  Subtitle: 'Comprehensive care services, with flexibility to meet your unique needs',
  CommonServices: {
    MobilitySupport: {
      Title: 'Mobility Support',
      Description: 'Assistance with walking, transferring, and safe movement.',
    },
    MealPrep: {
      Title: 'Meal Prep',
      Description: 'Preparation of nutritious meals tailored to dietary needs.',
    },
    MedicationSupport: {
      Title: 'Medication Support',
      Description: 'Medication reminders, management, and administration support.',
    },
    MemoryCare: {
      Title: 'Memory Care',
      Description: 'Support for individuals with memory-related conditions.',
    },
    Housekeeping: {
      Title: 'Housekeeping',
      Description: 'Light cleaning, laundry, and household organization.',
    },
    Bathing: {
      Title: 'Bathing',
      Description: 'Assistance with bathing and personal hygiene.',
    },
    Toiletting: {
      Title: 'Toiletting',
      Description: 'Support with toileting and continence care.',
    },
    OvernightCare: {
      Title: 'Overnight Care',
      Description: 'Care and supervision during nighttime hours.',
    },
    Dressing: {
      Title: 'Dressing',
      Description: 'Help with dressing and choosing appropriate clothing.',
    },
    BriefChanging: {
      Title: 'Brief Changing',
      Description: 'Assistance with changing briefs and incontinence care.',
    },
  },
  SpecializedServices: {
    DementiaAlzheimers: {
      Title: 'Dementia / Alzheimer\'s',
      Description: 'Specialized care for memory-related conditions with compassionate support.',
    },
    ParkinsonsDisease: {
      Title: 'Parkinson\'s Disease',
      Description: 'Expert assistance with movement disorders and daily living activities.',
    },
    StrokeRecovery: {
      Title: 'Stroke Recovery',
      Description: 'Rehabilitation support and assistance with recovery process.',
    },
    Diabetes: {
      Title: 'Diabetes',
      Description: 'Blood sugar monitoring, medication management, and dietary support.',
    },
    COPDRespiratory: {
      Title: 'COPD / Respiratory Conditions',
      Description: 'Breathing assistance, oxygen therapy support, and respiratory care.',
    },
    CancerChemotherapy: {
      Title: 'Cancer / Chemotherapy Support',
      Description: 'Compassionate care during treatment and recovery periods.',
    },
    PalliativeCare: {
      Title: 'Palliative Care',
      Description: 'Comfort-focused care to improve quality of life and provide dignity.',
    },
  },
};
